'use strict';
module.exports = require('./MultiSelect.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/multiselect/index.js
// module id = 39
// module chunks = 1